import { generatePath } from 'react-router-dom';
import { BellAlertIcon, BellIcon } from '@heroicons/react/24/outline';

import { Link } from '@/components/ui/link';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';
import { label } from '@/utils/format/label';

export type CardNbAlertsProps = {
  className?: string;
};

export function CardNbAlerts({ className }: CardNbAlertsProps) {
  const config = getConfig();

  return (
    <StatsBox
      className={className}
      icon={{ color: config.color, element: config.icon }}
      title="Alert Status"
      value={config.text}
    >
      <StatsBox.Action>
        <CardNbAlertsLink />
      </StatsBox.Action>
    </StatsBox>
  );
}

function CardNbAlertsLink() {
  const featureFlag = useFeatureFlag();

  if (featureFlag('alerts')) {
    return <Link to={generatePath('/alerts')}>View Alerts</Link>;
  }

  if (featureFlag('taskmanager')) {
    return <Link to={{ pathname: '/tasks' }}>View Alert Tasks</Link>;
  }

  return null;
}

type CardConfig = {
  color: 'yellow' | 'red' | 'green' | 'neutral';
  text: string;
  icon: React.ReactElement<{ className?: string }>;
};

function getConfig(): CardConfig {
  const criticalAlerts = 1;
  const warningAlerts = 0;

  if (criticalAlerts > 0) {
    return {
      color: 'red',
      text: label(
        [
          `${criticalAlerts} critical alert`,
          `${criticalAlerts} critical alerts`,
        ],
        criticalAlerts,
      ),
      icon: <BellAlertIcon />,
    };
  }

  if (warningAlerts > 0) {
    return {
      color: 'yellow',
      text: label(
        [`${warningAlerts} warning`, `${warningAlerts} warnings`],
        warningAlerts,
      ),
      icon: <BellAlertIcon />,
    };
  }

  return { color: 'neutral', text: 'No open alerts', icon: <BellIcon /> };
}
